import { SlidersOutlined } from "@ant-design/icons";
import { ADMIN_PREFIX_PATH } from "configs/AppConfig";

const masterNavTree = [
    {
        key: "manage_simpanan",
        path: `${ADMIN_PREFIX_PATH}/pengaturan-simpanan`,
        title: "Pengaturan Simpanan",
        icon: SlidersOutlined,
        breadcrumb: false,
    },
];

const navigationSavingsConfig = [...masterNavTree];

export default navigationSavingsConfig;
